import React, { useState, useEffect, useRef } from 'react'
import YouTube from 'react-youtube';
import v1 from './rawVideo/Anime Vibes loop (1).mp4';
import v2 from './rawVideo/Anime Central Loop (1).mp4';
import v3 from './rawVideo/Lofi Girl Loop.mp4';
import v4 from './rawVideo/Astral throb loop.mp4';
import v5 from './rawVideo/Lofi Synth wave.mp4';
import v6 from './rawVideo/Rock Classic Radio (1).mp4';
import v7 from './rawVideo/Spinnin Records loop.mp4';
import v8 from './rawVideo/Warm Night in Tokyo (1).mp4';
import v9 from './rawVideo/_1Hits radio loop.mp4';
import v10 from './rawVideo/2010s mix 1.mp4';


import electro from './electro.mp3'
import rain from './rain.mp3'
import forest from './forest.mp3'
import { IoPauseCircleOutline, IoPlayCircleOutline } from 'react-icons/io5';
import { BsCloudLightningRainFill, BsFillPlayFill } from 'react-icons/bs';
import { MdForest } from 'react-icons/md'
import { GoPulse } from 'react-icons/go'
import Landing from './Landing';
function Home() {
    const [isLandingVisible, setIsLandingVisible] = useState(true)
    const mainData = [
        {
            title: 'Anime Vibes',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/Anime%20Vibes.mp3?alt=media&token=cd3571c7-5f0d-4c64-a718-b03c01065b00',
            video: v1
        }, {
            title: 'Anime Central',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/Anime%20Central.mp3?alt=media&token=b36ccc8f-b57e-4202-9d36-711b6e6df706',
            video: v2
        }, {
            title: 'Lofi Girl',
            isYoutube: true,
            src: 'jfKfPfyJRdk',
            video: v3
        }, {
            title: 'Astral Throb',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/Astral%20Throb.mp3?alt=media&token=31fda0e6-4441-4171-9ccc-e4f2db030899',
            video: v4
        }, {
            title: 'Lofi Synth Waves',
            isYoutube: true,
            src: 'MVPTGNGiI-4',
            video: v5
        }
        ,
        {
            title: 'Rock Radio Classic',
            isYoutube: true,
            src: 'Va-h6WZPUzQ',
            video: v6
        },
        {
            title: 'Spinnin Records',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/Spinnin%20Recordssmp3.mp3?alt=media&token=c7d00460-e3c0-4dd0-bdad-e1908ebe64a38',
            video: v7
        }, {
            title: 'Warm Night in Tokyo',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/warm%20nights%20in%20tokyo.mp3?alt=media&token=e7e55915-553a-40b4-a3c7-ec41e10b8deb',
            video: v8
        }, {
            title: '#1 Hits Radio',
            isYoutube: true,
            src: 'uNd5kvrGHjk',
            video: v9
        }, {
            title: '2010s Feel Good Mix',
            isYoutube: false,
            src: 'https://firebasestorage.googleapis.com/v0/b/webapp-radio.appspot.com/o/2010s%20feel%20good%20mix.mp3?alt=media&token=6b9b3301-9875-4227-ad87-c5d3459b44d9',
            video: v10
        }


        // , {
        //     title: 'ChillAF Radio',
        //     isYoutube: true,
        //     src: '7bSlyM1allk',
        //     video: v12
        // },
    ]

    const videoRef = useRef()
    const yVideoRef = useRef()
    const mainAudioRef = useRef()
    const a1 = useRef()
    const [a1p, setA1p] = useState(false)

    const a2 = useRef()
    const [a2p, setA2p] = useState(false)

    const a3 = useRef()
    const [a3p, setA3p] = useState(false)

    const [current, setCurrent] = useState(mainData[0])
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 1,
        },
    };
    const [volume, setVolume] = useState(50); // initial volume is 100%

    const handleVolumeChangeYoutube = (event) => {
        const newVolume = event.target.value;
        setVolume(newVolume);
        yVideoRef.current.internalPlayer.setVolume(newVolume);
    };
    const handleVolumeChangeMp3 = (event) => {
        const newVolume = event.target.value;
        mainAudioRef.current.volume = newVolume / 100
        setVolume(event.target.value)
    };
    const [videoPlaying, setVideoPlaying] = useState(false)
    useEffect(() => {
        if (!isLandingVisible) {
            const video = document.getElementById('#myVideo');
            video.addEventListener("playing", function () {
                setVideoPlaying(true)
            });
            video.addEventListener("pause", function () {
                setVideoPlaying(false)
            });
            const a1t = document.getElementById('#a1');
            const a2t = document.getElementById('#a2');
            const a3t = document.getElementById('#a3');

            a1t.addEventListener("playing", function () {
                setA1p(true)
            });
            a1t.addEventListener("pause", function () {
                setA1p(false)
            });
            a2t.addEventListener("playing", function () {
                setA2p(true)
            });
            a2t.addEventListener("pause", function () {
                setA2p(false)
            });
            a3t.addEventListener("playing", function () {
                setA3p(true)
            });
            a3t.addEventListener("pause", function () {
                setA3p(false)
            });
        }
    }, [isLandingVisible])

    if (isLandingVisible) {
        return (
            <Landing setIsLandingVisible={setIsLandingVisible} isLandingVisible={isLandingVisible} />
        )
    }
    return (
        <div className='home_container'>
            <div style={{ zIndex: '999', position: 'absolute', top: '10px', margin: '0px 20px' }}>
                <h1 style={{ color: '#fff', fontWeight: '600' }}>RadioBig</h1>
            </div>

            <div style={{ zIndex: '999', borderRight: '3px solid #cccccc70', width: '200px', height: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'absolute', top: '50%', transform: 'translate(0%, -50%)', margin: '0px 20px', overflow: 'scroll' }}>
                {
                    mainData.map(data => {
                        return (
                            <div onClick={() => { setCurrent(data) }} style={{ display: 'flex', cursor: 'pointer', justifyContent: 'left', alignItems: 'center', color: '#fff', textShadow: '0px 0px 5px #000000', marginBottom: '10px', borderRadius: '2px' }}>
                                <BsFillPlayFill style={{ marginRight: '5px' }} />{data.title}
                            </div>
                        )
                    })
                }
            </div >
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%', background: '#000' }}>
                {
                    current.isYoutube ?
                        <YouTube
                            ref={yVideoRef}
                            style={{ width: '100%', height: '0px' }} videoId={current.src} opts={opts} />
                        :
                        <audio src={current.src} autoPlay
                            ref={mainAudioRef} />
                }
                <video src={current.video}
                    autoPlay
                    loop
                    id='#myVideo'
                    autoFocus
                    ref={videoRef}
                    volume={volume}
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'fill', position: 'absolute', top: '0', left: '0'
                    }}>
                </video>
            </div>
            <div style={{ zIndex: '999', position: 'absolute', bottom: '10px', left: '0', width: '100vw', height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', overflow: 'scroll' }}>
                {
                    videoRef &&
                    <div>
                        {
                            !videoPlaying ?
                                <div onClick={() => { videoRef && videoRef.current.play(); yVideoRef?.current?.internalPlayer?.playVideo(); mainAudioRef?.current?.play() }} style={{ display: 'flex', justifyContent: 'left', alignItems: 'flex-start', color: '#fff', textShadow: '0px 0px 5px #000000', marginBottom: '10px', borderRadius: '2px' }}>
                                    <IoPlayCircleOutline style={{ fontSize: '5em' }} />
                                </div>
                                :
                                <div onClick={() => { videoRef && videoRef?.current?.pause(); yVideoRef?.current?.internalPlayer?.pauseVideo(); mainAudioRef?.current?.pause() }} style={{ display: 'flex', justifyContent: 'left', alignItems: 'flex-start', color: '#fff', textShadow: '0px 0px 5px #000000', marginBottom: '10px', borderRadius: '2px' }}>
                                    <IoPauseCircleOutline style={{ fontSize: '5em' }} />
                                </div>
                        }
                    </div>
                }
                <input
                    className='volume-seeker'
                    style={{ marginLeft: '20px', marginTop: '-5px', marginRight: '-100px' }}
                    type="range"
                    min="1"
                    max="100"
                    step="1"
                    value={volume}
                    onChange={current.isYoutube ? handleVolumeChangeYoutube : handleVolumeChangeMp3}
                />
            </div >
            <div style={{ zIndex: '999', position: 'absolute', bottom: '10px', right: '30px', width: 'min-content', height: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', overflow: 'scroll' }}>
                <div style={{ position: 'relative' }}>
                    <BsCloudLightningRainFill
                        onMouseEnter={() => { document.getElementById('#a1v').style.display = 'block' }}
                        onMouseLeave={() => { document.getElementById('#a1v').style.display = 'none' }}
                        onClick={() => { (a1p ? a1.current.pause() : a1.current.play()) }}
                        style={{ margin: '10px', padding: '10px', color: a1p ? '#fff' : '#cccccc70', border: '2px solid #cccccc70', borderRadius: '50vh', fontSize: '1.3em' }} />
                    <input
                        className='volume-seeker'
                        style={{ position: 'absolute', top: '0px', left: '0px', display: 'none' }}
                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        id='#a1v'
                        onMouseEnter={() => { document.getElementById('#a1v').style.display = 'block' }}
                        onChange={(e) => { a1.current.volume = e.target.value; }}
                    />
                    <audio id="#a1" ref={a1} src={rain} loop />
                </div>
                <div style={{ position: 'relative' }}>
                    <MdForest
                        onMouseEnter={() => { document.getElementById('#a2v').style.display = 'block' }}
                        onMouseLeave={() => { document.getElementById('#a2v').style.display = 'none' }}
                        onClick={() => { (a2p ? a2.current.pause() : a2.current.play()) }}
                        style={{ margin: '10px', padding: '10px', color: a2p ? '#fff' : '#cccccc70', border: '2px solid #cccccc70', borderRadius: '50vh', fontSize: '1.3em' }} />

                    <input
                        className='volume-seeker'
                        style={{ marginLeft: '00px', position: 'absolute', top: '0px', left: '-10px', display: 'none' }}

                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        id='#a2v'
                        onMouseEnter={() => { document.getElementById('#a2v').style.display = 'block' }}
                        onChange={(e) => { a2.current.volume = e.target.value; }}
                    />
                    <audio id="#a2" ref={a2} src={forest} loop />
                </div>
                <div style={{ position: 'relative' }}>
                    <GoPulse
                        onMouseEnter={() => { document.getElementById('#a3v').style.display = 'block' }}
                        onMouseLeave={() => { document.getElementById('#a3v').style.display = 'none' }}
                        onClick={() => { (a3p ? a3.current.pause() : a3.current.play()) }}
                        style={{ margin: '10px', padding: '10px', color: a3p ? '#fff' : '#cccccc70', border: '2px solid #cccccc70', borderRadius: '50vh', fontSize: '1.3em' }} />

                    <input
                        className='volume-seeker'
                        style={{ position: 'absolute', top: '0px', left: '-20px', display: 'none' }}

                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        id='#a3v'
                        onMouseEnter={() => { document.getElementById('#a3v').style.display = 'block' }}
                        onChange={(e) => { a3.current.volume = e.target.value; }}
                    />
                    <audio id="#a3" ref={a3} src={electro} loop />
                </div>
            </div>
        </div >
    )
}

export default Home